var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MatcRule MatcWorkFlowSettings MatcWorkFlowSettingsSimple"},[_c('div',{staticClass:"MatcWorkFlowSettingsSteps"},[_vm._v(" Step 1 ")]),_c('div',{ref:"cntr",staticClass:"MatcWorkFlowSettingsCntr"})])}
var staticRenderFns = []

export { render, staticRenderFns }